import produce from 'immer';
import actions from './actions';

const initialState = {
	initialized: false,
};
/* eslint-disable default-case, no-param-reassign */
const reducer = (state = initialState, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			case actions.INITIALIZED:
				draft.initialized = true;
				break;
		}
	});

export default reducer;
